import styled from 'styled-components'

export const CollectionContainer = styled.div`
  width: 100%;
  margin: 0 auto;

  @media screen and (min-width: 768px) {
    max-width: var(--grid-max-width);
  }
`

const rowGap = 20

export const Grid = styled.div<{
  fixedHeight?: boolean
  totalProductsLength?: number
}>`
  display: grid;
  min-height: ${({ fixedHeight, totalProductsLength = 0 }) =>
    fixedHeight
      ? `calc(${totalProductsLength * 690}px + ${rowGap * (totalProductsLength - 1)}px)`
      : 'auto'};
  grid-auto-rows: minmax(auto, max-content);
  grid-template-columns: repeat(1, minmax(0, 1fr));
  grid-column-gap: 0.6rem;
  grid-row-gap: ${rowGap}px;
  align-items: center;
  margin: 0 auto;

  @media (min-width: 768px) {
    padding: 0 1.5rem 2rem 1.5rem;
    min-height: ${({ fixedHeight, totalProductsLength = 0 }) =>
      fixedHeight
        ? `calc(${(totalProductsLength / 2) * 720}px + ${rowGap * (totalProductsLength / 2 - 1)}px)`
        : 'auto'};

    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (min-width: 992px) {
    min-height: ${({ fixedHeight, totalProductsLength = 0 }) =>
      fixedHeight
        ? `calc(${(totalProductsLength / 3) * 626}px + ${rowGap * (totalProductsLength / 3 - 1)}px)`
        : 'auto'};
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (min-width: 1220px) {
    min-height: ${({ fixedHeight, totalProductsLength = 0 }) =>
      fixedHeight
        ? `calc(${(totalProductsLength / 3) * 720}px + ${rowGap * (totalProductsLength / 3 - 1)}px)`
        : 'auto'};
    padding: 0;
  }

  .category-header {
    padding: 0;

    @media (min-width: 768px) {
      margin: 0 auto;
    }
  }

  .apparel-product-card {
    flex-shrink: 0;
    flex-grow: 1;
    margin-bottom: 2rem;
  }
`

export const CardContent = styled.div`
  display: flex;
  justify-content: center;

  @media (min-width: 768px) {
    height: 100%;
  }
`
